import MayorStories from '../../../../screens/MayorStories';
import { useDirectedPopup } from '../../../../ui/popupDirector/popupDirector';

interface MayorStoriesHostProps {
  showMayorStories: boolean;
  handleElectionVote: () => void;
  handleElectionRegister: () => void;
  dismissMayorStories: () => void;
}

/**
 * MayorStories — the "mayor elections are on" announcement, as a centered
 * ModalFrame dialog on the map (night town-hall + gold Island Event card from
 * the former election story). Separate from the onboarding stories: it is only
 * shown after onboarding, and takes its turn through the popup director.
 */
export default function MayorStoriesHost({
  showMayorStories,
  handleElectionVote,
  handleElectionRegister,
  dismissMayorStories,
}: MayorStoriesHostProps) {
  const visible = useDirectedPopup('mayorStories', showMayorStories);
  if (!visible) return null;

  return (
    <MayorStories
      onVote={handleElectionVote}
      onRegister={handleElectionRegister}
      onClose={dismissMayorStories}
    />
  );
}
